import { useState } from 'react'
import { useMutation } from '@apollo/client'
import {
  MoveCitations,
  MoveCitationsVariables,
} from '@chegg-wt/core/queries/MoveCitations'
import { MOVE_CITATIONS } from '@chegg-wt/core/queries/Citations'
import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'
import { Citation } from '../types/redux-citation-api'
import { client } from '../api/graphApi'

interface UseMoveCitationsProps {
  moveCitations: (
    projectId: string,
    citations: Citation[],
    onCompleted?: () => void
  ) => Promise<void>
  errorMsg: string
}

export const useMoveCitations = (): UseMoveCitationsProps => {
  const [errorMsg, setErrorMsg] = useState('')
  const [moveCitations] = useMutation<MoveCitations, MoveCitationsVariables>(
    MOVE_CITATIONS,
    {
      client,
    }
  )

  const handleMove = async (
    projectId: string,
    citations: Citation[],
    onCompleted?: (data?: any) => void
  ) => {
    if (!projectId || !citations || !citations.length) {
      return
    }

    moveCitations({
      variables: {
        projectId,
        citationIds: citations.map((c) => c.id),
      },
    })
      .then(() => {
        if (onCompleted) {
          onCompleted()
        }
      })
      .catch((e) => {
        trackWithoutThrow(e)
        setErrorMsg('An error occurred moving citations.')
      })
  }

  return {
    moveCitations: handleMove,
    errorMsg,
  }
}
